import { NativeStackScreenProps } from '@react-navigation/native-stack';
import { NavigationStacks, Screens, Stacks } from 'components/Navigation/types';
import { useSelector } from 'hooks/useSelector';
import { shouldRedirectWeb } from 'lib/riskbase';
import * as React from 'react';
import { ImageBackground } from 'react-native';
import { selectUserId } from 'store/auth/selectors';

type Props = NativeStackScreenProps<
  NavigationStacks[Stacks.ROOT],
  Screens.RootAuth
>;

const AssetBackdropJpeg = require('assets/backdrop.jpg');

export const AuthScreen: React.FC<Props> = ({ navigation }) => {
  const hasUserId = !!useSelector(selectUserId);

  React.useEffect(() => {
    if (hasUserId) {
      // navigation.replace(Screens.RootPage);
    } else {
      const redirectTo = shouldRedirectWeb();
      if (redirectTo) {
        window.location.replace(redirectTo);
      }
    }
  }, [navigation, hasUserId]);

  return (
    <ImageBackground
      style={{
        position: 'absolute',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        width: '100%',
        height: '100%',
        opacity: 0.2,
      }}
      resizeMode="cover"
      source={AssetBackdropJpeg}
    />
  );
};
